import { render } from "./OrderFly.vue?vue&type=template&id=10c6aec0"
import script from "./OrderFly.vue?vue&type=script&lang=js"
export * from "./OrderFly.vue?vue&type=script&lang=js"

import "./OrderFly.vue?vue&type=style&index=0&id=10c6aec0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__